import React from 'react';
// eslint-disable-next-line
import { Dropdown, FontSizes, FontWeights, Label, Link } from '@fluentui/react';
import { QuestionGroup } from './QuestionGroup';
import './Questionnaire.css';

export function Questionnaire(props) {
    const { dispatch, state, submitQuote } = props;

    return (
        <div className="questionnaire-container">

            <div className="questionnaire-header-container">
            </div>

            <hr/>

            <QuestionGroup
                dispatch={dispatch}
                state={state}
            />
            { state.questions.isDotNumberValid && (
                <div className="questionnaire-button-container">
                    <Link className="button" onClick={submitQuote}>Get Your Results</Link>
                </div>
            )}
            { state.questions.submitError !== '' && (
                <Label style={{color: 'red'}}>
                    {state.questions.submitError}
                </Label>
            )}
        </div>
    );
};